import React from 'react';
import ButtonInc from '../../../../../../shared-ui/ButtonInc';
import { getPartner } from '../../../../../../lib/access.es6';

/**
 * Summary screen showing final changes before confirmation
 */
const SummaryScreen = ({
  policy,
  currentCoverageType,
  targetCoverageType,
  finalPrincipal,
  removedMembers,
  isPrincipalSwapped,
  oldPrincipalName,
  oldPremium,
  newPremium,
  onBack,
  onConfirm
}) => {
  const currencyCode = getPartner().country.currency_code;
  const premiumChange = newPremium - oldPremium;
  const changeType = premiumChange > 0 ? 'Increase' : (premiumChange < 0 ? 'Decrease' : 'No Change');

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{
        marginBottom: '30px',
        paddingBottom: '20px',
        borderBottom: '2px solid #e0e0e0'
      }}>
        <h1 style={{ fontSize: '26px', fontWeight: 'bold', marginBottom: '8px', color: '#032A37' }}>
          Confirm Coverage Change
        </h1>
        <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
          Review the changes before submitting
        </p>
      </div>

      {/* Section 1: Coverage Change Summary */}
      <section style={{
        marginBottom: '30px',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        padding: '20px',
        border: '1px solid #ddd'
      }}>
        <h6 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px', color: '#032A37' }}>
          Coverage Type Change
        </h6>
        <div style={{ fontSize: '16px', lineHeight: '1.8' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <span style={{ color: '#666', width: '100px' }}>From:</span>
            <span style={{ fontWeight: '600' }}>{currentCoverageType}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ color: '#666', width: '100px' }}>To:</span>
            <span style={{ fontWeight: '600', color: '#28a745' }}>{targetCoverageType}</span>
          </div>
        </div>
      </section>

      {/* Section 2: Principal Member (if swapped) */}
      {isPrincipalSwapped && (
        <section style={{
          marginBottom: '30px',
          backgroundColor: '#fff3cd',
          borderRadius: '8px',
          padding: '20px',
          border: '1px solid #ffc107'
        }}>
          <h6 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px', color: '#856404' }}>
            Principal Member Changed
          </h6>
          <div style={{ fontSize: '16px', lineHeight: '1.8' }}>
            <div style={{ marginBottom: '10px' }}>
              <span style={{ color: '#856404' }}>Previous Principal:</span>{' '}
              <span style={{ fontWeight: '600' }}>{oldPrincipalName}</span>
            </div>
            <div>
              <span style={{ color: '#856404' }}>New Principal:</span>{' '}
              <span style={{ fontWeight: '600', color: '#28a745' }}>
                {finalPrincipal.first_name} {finalPrincipal.last_name}
              </span>
            </div>
          </div>
        </section>
      )}

      {/* Section 3: Final Principal Details */}
      <section style={{ marginBottom: '30px' }}>
        <h6 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px', color: '#032A37' }}>
          Final Principal Member
        </h6>
        <table style={{
          width: '100%',
          background: '#FFFFFF',
          border: '1px solid #A7A7A7',
          borderCollapse: 'collapse'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7',
                textAlign: 'left'
              }}>Name</th>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7'
              }}>Benefits</th>
              <th style={{
                fontFamily: 'Lato',
                fontWeight: 700,
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7',
                textAlign: 'right'
              }}>Premium</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{
                fontFamily: 'open sans',
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7'
              }}>
                {finalPrincipal.first_name} {finalPrincipal.last_name}
              </td>
              <td style={{
                fontFamily: 'open sans',
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7'
              }}>
                <ul style={{ margin: 0, paddingLeft: 0, listStyle: 'none' }}>
                  {finalPrincipal.benefits && finalPrincipal.benefits.map((benefit, i) => (
                    <li key={i} style={{ marginBottom: '4px' }}>
                      {benefit.type.toLowerCase()}{' '}
                      <strong>
                        {currencyCode} {((benefit.cover_amount_in_cents || 0) / 100).toLocaleString()}
                      </strong>
                    </li>
                  ))}
                </ul>
              </td>
              <td style={{
                fontFamily: 'open sans',
                fontSize: '12px',
                color: '#000000',
                padding: '10px',
                borderRight: '1px solid #A7A7A7',
                textAlign: 'right',
                fontWeight: '600'
              }}>
                {currencyCode} {(newPremium / 100).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* Section 4: Removed Members (if any) */}
      {removedMembers && removedMembers.length > 0 && (
        <section style={{ marginBottom: '30px' }}>
          <h6 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px', color: '#032A37' }}>
            Members Being Removed ({removedMembers.length})
          </h6>
          <table style={{
            width: '100%',
            background: '#FFFFFF',
            border: '1px solid #A7A7A7',
            borderCollapse: 'collapse'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f8d7da' }}>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'left'
                }}>Name</th>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7'
                }}>Relationship</th>
                <th style={{
                  fontFamily: 'Lato',
                  fontWeight: 700,
                  fontSize: '12px',
                  color: '#000000',
                  padding: '10px',
                  borderRight: '1px solid #A7A7A7',
                  textAlign: 'right'
                }}>Premium</th>
              </tr>
            </thead>
            <tbody>
              {removedMembers.map((member, index) => (
                <tr key={member.uuid || index} style={{ borderTop: '1px solid #A7A7A7' }}>
                  <td style={{
                    fontFamily: 'open sans',
                    fontSize: '12px',
                    color: '#000000',
                    padding: '10px',
                    borderRight: '1px solid #A7A7A7'
                  }}>
                    {member.first_name} {member.last_name}
                  </td>
                  <td style={{
                    fontFamily: 'open sans',
                    fontSize: '12px',
                    color: '#000000',
                    padding: '10px',
                    borderRight: '1px solid #A7A7A7'
                  }}>
                    {member.relationship}
                  </td>
                  <td style={{
                    fontFamily: 'open sans',
                    fontSize: '12px',
                    color: '#000000',
                    padding: '10px',
                    borderRight: '1px solid #A7A7A7',
                    textAlign: 'right',
                    fontWeight: '600'
                  }}>
                    {currencyCode} {((member.premium_amount_in_cents || 0) / 100).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}

      {/* Section 5: Premium Summary */}
      <section style={{
        marginBottom: '30px',
        backgroundColor: premiumChange < 0 ? '#d4edda' : '#fff3cd',
        borderRadius: '8px',
        padding: '20px',
        border: `1px solid ${premiumChange < 0 ? '#c3e6cb' : '#ffc107'}`
      }}>
        <h6 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '15px', color: '#032A37' }}>
          Premium Summary
        </h6>
        <table style={{ width: '100%', fontSize: '16px' }}>
          <tbody>
            <tr>
              <td style={{ padding: '8px 0', color: '#666' }}>Old Total Premium:</td>
              <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>
                {currencyCode} {(oldPremium / 100).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td style={{ padding: '8px 0', color: '#666' }}>New Total Premium:</td>
              <td style={{ padding: '8px 0', textAlign: 'right', fontWeight: '600' }}>
                {currencyCode} {(newPremium / 100).toFixed(2)}
              </td>
            </tr>
            <tr style={{ borderTop: '2px solid #032A37' }}>
              <td style={{ padding: '12px 0', fontWeight: '600', fontSize: '18px' }}>
                {changeType}:
              </td>
              <td style={{
                padding: '12px 0',
                textAlign: 'right',
                fontWeight: '700',
                fontSize: '20px',
                color: premiumChange < 0 ? '#28a745' : '#dc3545'
              }}>
                {premiumChange < 0 ? '-' : '+'}{currencyCode} {Math.abs(premiumChange / 100).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '30px' }}>
        <ButtonInc
          btnType="secondary"
          onClick={onBack}
          style={{ border: '1px solid #032A37' }}
        >
          Back
        </ButtonInc>
        <ButtonInc
          btnType="primary"
          onClick={onConfirm}
        >
          Confirm Amendment
        </ButtonInc>
      </div>
    </div>
  );
};

export default SummaryScreen;
